import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../../Assets/0a-exporter";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import "./common-footer.style.scss";
export default function CommonFooter() {
  const context = React.useContext(MainContext);
  const { userDetails, updateState } = context;
  return (
    <footer className="common-landing-footer">
      <div className="clf-header">
        <div className="clf-header-left">
          <img src={Images.mainLogo} />
        </div>
        <div className="clf-header-right">
          <a href="https://www.facebook.com/acadHR/" target="_blank">
            <img src={Images.facebookWhiteLogo} />
          </a>
          <a href="https://twitter.com/acadshr?lang=en" target="_blank">
            <img src={Images.twitterWhite} />
          </a>
          <a href="https://www.linkedin.com/company/acadhr" target="_blank">
            <img src={Images.linkedInLogo} />
          </a>
        </div>
      </div>
      <div className="clf-main">
        <div className="clf-main-left">
          <ul>
            <h6>For Candidates</h6>
            <li>
              <Link onClick={() =>{ window.scroll({ top: 0 })}} to="/user">
                Browse Jobs
              </Link>{" "}
            </li>
            <li>
              <Link onClick={()=>{if(!userDetails){updateState("routeLink","/user/profile");} }} to={userDetails ? "/user/profile" : "/login/candidate"}>
                Add Resume
              </Link>{" "}
            </li>
            {/* <li>Job Alerts</li> */}
            <li>
              <Link onClick={()=>{if(!userDetails){updateState("routeLink","/user/list/saved-jobs");} }} to={userDetails?"/user/list/saved-jobs":"/login/candidate"}>My Bookmarks</Link>{" "}
            </li>
          </ul>
          <ul>
            <h6>For Institutes</h6>
            <li>
              <Link to="/login/institution">Browse Candidates</Link>{" "}
            </li>
            <li>
              <Link to="/login/institution">Post a job</Link>
            </li>
            <li>
              <Link to="/login/institution">Plans & Pricing</Link>
            </li>
          </ul>
          <ul>
            <h6>Account</h6>
            <li>
              <Link onClick={() => window.scroll({ top: 0 })} to="/login">
                Login
              </Link>
            </li>
            <li>
              <Link to={userDetails ? "/user/profile" : "/login/candidate"}>
                {" "}
                My account
              </Link>
            </li>
          </ul>
          <ul>
            <h6>Company</h6>
            <li>
              <Link to="/about">About us</Link>{" "}
            </li>
            <li>
              <a href="http://13.127.213.59" target="_blank">
                Blogs
              </a>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy policy</Link>{" "}
            </li>
            <li>
              <Link to="/terms-and-condition">Terms of use</Link>
            </li>
          </ul>
          <ul>
            <h6>Helpful Links</h6>
            <li>
              <Link onClick={() => window.scroll({ top: 0 })} to="/help">
                FAQs
              </Link>{" "}
            </li>
            <li>
              <Link onClick={() => window.scroll({ top: 0 })} to="/contact">
                Contact
              </Link>{" "}
            </li>
          </ul>
        </div>
        <div className="clf-main-right">
          <h5>Download the App</h5>
          <p>You can get the updates for the jobs at your finger tips</p>
          <div>
              <img src={Images.gplayStoreFull} />
              <img src={Images.appStoreFull} />
          </div>
        </div>
      </div>
      <div className="clf-footer">
        <p>
          © 2021 <span>AcadsHr</span>. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
